import { DataTable } from '@plato/ui-legacy/components/list-views/data-table';
import { TableHeader } from '@plato/ui-legacy/components/tables/table-header';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { useMemo } from 'react';
import { api } from '../../../utils/api.ts';
import { useProductAvailibilityColumns } from '../../list-views/columns/use-product-availibility-columns.tsx';

type Props = {
    erpProductId: string;
};

export function InventoryDetailsAvailability({ erpProductId }: Props) {
    const availibilityColumns = useProductAvailibilityColumns();

    const { data: availibilityRawData, isLoading: isLoadingAvailibility } =
        api.platoUser.grid.getManyStorageStockLevels.get.useQuery({
            productVariantId: erpProductId,
        });

    const availibilityCount = availibilityRawData ? availibilityRawData.length : 0;

    const availibilityData = useMemo(
        () => (availibilityRawData ? availibilityRawData : []),
        [availibilityRawData],
    );

    const availibilityTable = useReactTable({
        data: availibilityData,
        columns: availibilityColumns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <>
            <DataTable
                isLoading={isLoadingAvailibility}
                table={availibilityTable}
                columns={availibilityColumns}
            />
            <TableHeader count={availibilityCount} isLoadingCount={isLoadingAvailibility} />
        </>
    );
}
